class SelectOption {
  constructor(options = {}) {
    options = options || {}
    this.label = options.label || ''
    this.value = options.value
    this.selected = (typeof options.selected === 'boolean') ? options.selected : false
  }

  // Class methods
  static init(options) {
    if (options instanceof SelectOption) {
      return options
    }
    const instance = new SelectOption(options)
    return instance.isValid ? instance : null
  }
  static initFromArray(arr) {
    if (Array.isArray(arr)) {
      return arr.map(this.init)
    }
    return []
  }
  static initOnlyValidFromArray(arr = []) {
    return this.initFromArray(arr).filter((i) => i)
  }
  static toogleSelected() {
    this.selected = !this.selected
  }
  get isValid() {
    return !!this
  }
}

export default {
  SelectOption
}
export {
  SelectOption
}
